import axios from 'axios';

export const URL_API = axios.create({
    // baseURL: 'http://127.0.0.1/api_app/index.php'
    baseURL: 'https://hdltechnology.com.mx/capacitacion/api/index.php'
    // baseURL: 'https://hdltechnology.com.mx/sistema/api/index.php'
})